export const PREVIEW_BACKEND_CHOICE_COOKIE = 'rio_preview_api';
export const PREVIEW_BACKEND_DEFAULT_COOKIE = 'rio_preview_default';

export const DEV_BACKEND_NAME = 'dev';
export const DEV_BACKEND_URL = 'https://dev-api.revers.io';

export const PREVIEW_BACKEND_URL_SUFFIX = '.preview.revers.io';
export const PREVIEW_HOSTNAME_SUFFIXES = [
  '.preview.dev-app.revers.io',
  '.preview.dev-field-service-app.revers.io',
  '.preview.dev-onboarding.revers.io',
];

const PREVIEW_FRONT_HOSTNAME_SUFFIXES = [
  '.preview-front.dev-app.revers.io',
  '.preview-front.dev-field-service-app.revers.io',
  '.preview-front.dev-onboarding.revers.io',
];

const ALL_PREVIEW_HOSTNAME_SUFFIXES = [
  ...PREVIEW_HOSTNAME_SUFFIXES,
  ...PREVIEW_FRONT_HOSTNAME_SUFFIXES,
];

export const getIsPreviewHostname = (hostname: string): boolean =>
  ALL_PREVIEW_HOSTNAME_SUFFIXES.some((suffix) => hostname.endsWith(suffix));

export const LOCALHOST_PREVIEW_HOSTNAME = 'localhost.preview.dev-app.revers.io';
export const LOCALHOST_BACKEND_URL = 'https://localhost';

const PREVIEW_BACKEND_NAME_PATTERN = /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/;

export const getIsValidPreviewBackendName = (
  name?: string | null,
): name is string => !!name && PREVIEW_BACKEND_NAME_PATTERN.test(name);

const HTTPS_PREFIX = 'https://';

export function getPreviewBackendName(backendUrl: string): string | undefined {
  const url = backendUrl.replace(/\/+$/, '');

  if (url === DEV_BACKEND_URL) {
    return DEV_BACKEND_NAME;
  }

  const name =
    url.startsWith(HTTPS_PREFIX) && url.endsWith(PREVIEW_BACKEND_URL_SUFFIX)
      ? url.slice(HTTPS_PREFIX.length, -PREVIEW_BACKEND_URL_SUFFIX.length)
      : undefined;

  return getIsValidPreviewBackendName(name) ? name : undefined;
}

interface ResolvePreviewBackendUrlArgs {
  hostname: string;
  choice?: string | null;
  previewDefault?: string | null;
  configuredUrl?: string;
  hostnameSuffixes?: string[];
  backendUrlSuffix?: string;
  devBackendUrl?: string;
}

function getHostnameBackendName({
  hostname,
  hostnameSuffixes,
}: {
  hostname: string;
  hostnameSuffixes: string[];
}): string | undefined {
  const suffix = hostnameSuffixes.find((candidate) =>
    hostname.endsWith(candidate),
  );

  return suffix ? hostname.slice(0, -suffix.length) : undefined;
}

export const getPreviewSlug = (hostname: string): string | undefined =>
  getHostnameBackendName({
    hostname,
    hostnameSuffixes: ALL_PREVIEW_HOSTNAME_SUFFIXES,
  });

export function resolvePreviewBackendUrl({
  hostname,
  choice,
  previewDefault,
  configuredUrl,
  hostnameSuffixes = PREVIEW_HOSTNAME_SUFFIXES,
  backendUrlSuffix = PREVIEW_BACKEND_URL_SUFFIX,
  devBackendUrl = DEV_BACKEND_URL,
}: ResolvePreviewBackendUrlArgs): string {
  const name = [
    choice,
    previewDefault,
    getHostnameBackendName({ hostname, hostnameSuffixes }),
  ].find(getIsValidPreviewBackendName);

  if (name === DEV_BACKEND_NAME) {
    return devBackendUrl;
  }

  if (name) {
    return `${HTTPS_PREFIX}${name}${backendUrlSuffix}`;
  }

  return configuredUrl || devBackendUrl;
}
